// ======================================================================
// File Name       : DateTimeWithValidate
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import moment from 'moment';
import Calendar from 'rc-calendar';
import 'rc-calendar/assets/index.css';
import jaJP from 'rc-calendar/lib/locale/ja_JP';
import Picker from 'rc-calendar/lib/Picker';
import TimePickerPanel from 'rc-time-picker/lib/Panel';
import React from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import MessageValidate from '../components/MessageValidate';
import { DEFAULT_DATE_FORMAT, DEFAULT_DATE_FORMAT_SHORT_DETAIL, ERROR_TYPE } from '../constants/index';
import {
  DATE_INCLUDE_TODAY,
  handleCalendarIconClick,
  MAX_DATE,
  MAX_DATE_NO_SECOND,
  MIN_DATE,
  MIN_DATE_NO_SECOND,
  MIN_MAX_DATE_TXT,
  PRECENT_DAY,
  validateDateTime,
  jaJPCustom,
} from '../utils/index';
import * as MessageTemplate from '../constants/MessageTemplate';

require('moment/locale/ja');

class DateTimeWithValidate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorType: ERROR_TYPE.ERROR,
      errorVisible: false,
      errorMessage: '公開期間に入力できない文字が含まれています。',
    };
    this.validation = this.validation.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.parseMinMax = this.parseMinMax.bind(this);
    this.minMaxDateTxt = props.minMaxDateTxt ? props.minMaxDateTxt : MIN_MAX_DATE_TXT;
    // #7230 START
    const { showTime } = props;
    this.dateFormat = DEFAULT_DATE_FORMAT;
    if (showTime) {
      this.dateFormat = DEFAULT_DATE_FORMAT_SHORT_DETAIL;
    }
    // #7230 END
    this.messageTemplate = this.messageTemplate.bind(this);
  }

  parseMinMax(date) {
    const { showTime } = this.props;
    if (date) {
      if (validateDateTime(date, this.dateFormat, this.minMaxDateTxt) && date !== this.minMaxDateTxt) {
        date = moment(date);
      }
      if (date.isValid && date.isValid()) {
        // #7230 START
        // call clone() to not mutation original date
        let checkDateRange = date.clone().startOf('day').isSameOrBefore(MIN_DATE)
          || date.clone().startOf('day').isSameOrAfter(MAX_DATE);

        if (showTime) {
          checkDateRange = date.isSameOrBefore(MIN_DATE_NO_SECOND) || date.isSameOrAfter(MAX_DATE_NO_SECOND);
        }
        if (checkDateRange) {
          date = '';
        }
        // #7230 END
      }
    }
    return date;
  }

  handleTimeChange(dateString) {
    // #7230 START
    const { showTime } = this.props;
    // use clone() to not mutation original dateString
    let selectedDateString = '';
    if (dateString) {
      if (showTime) {
        selectedDateString = dateString;
      } else {
        selectedDateString = dateString.clone().startOf('day');
      }
    }
    this.props.onChange(selectedDateString);
    // #7230 END
  }

  messageTemplate(label, msg) {
    return msg.replace('{0}', label);
  }

  validation() {
    let isValid = true;
    if (this.props.value) {
      isValid = validateDateTime(this.props.value, this.dateFormat, this.minMaxDateTxt);
      this.setState({
        errorVisible: !isValid,
      });
      return isValid;
    }
    if (this.props.required) {
      if (!this.props.value
          || (this.props.value
          && this.props.value === '')) {
        const label = this.props.label ? this.props.label : '';
        this.setState({
          errorVisible: true,
          errorMessage: this.messageTemplate(label, MessageTemplate.W_REQUIRED),
        });
        return false;
      }
    }
    return isValid;
  }

  disabledDate(current) {
    if (!current) {
      return false;
    }
    return current.isBefore(PRECENT_DAY);
  }
  // #5908 - disable from current date.
  disableCurrentdDate(current) {
    if (!current) {
      return false;
    }
    return current.isAfter(PRECENT_DAY);
  }

  // #7062 START
  disableIncludeToDay(current) {
    return current && current.isBefore(DATE_INCLUDE_TODAY);
  }
  // #7062 END

  componentWillReceiveProps(nextProps) {
    const value = { ...nextProps.value };
    this.setState({
      value,
    }, () => {
      if (this.state.value && Object.keys(this.state.value).length) {
        this.validation();
      }
    });
  }

  render() {
    let date = this.props.value;
    date = this.parseMinMax(date);
    let dateValue = '';
    let disabledDate = () => false;
    if (date && date.format) {
      dateValue = date.format(this.dateFormat);
    }
    const { shouldDisableDate, disableCurrentDate, disableIncludeToDay, showTime } = this.props;
    if (shouldDisableDate) {
      disabledDate = this.disabledDate;
    }
    if (disableCurrentDate) {
      disabledDate = this.disableCurrentdDate;
    }
    // #7062 START
    if (disableIncludeToDay) {
      disabledDate = this.disableIncludeToDay;
    }
    // #7062 END
    // #7230 START
    let timePickerElement = null;
    if (showTime) {
      const newDate = new Date();
      const defaultTimeValue = moment(newDate, 'HH:mm');
      timePickerElement = (
        <TimePickerPanel defaultValue={defaultTimeValue} showSecond={false} minuteStep={this.props.minuteStep} />
      );
    }
    // #7230 END

    const calendar = (
      <Calendar
        showDateInput
        showWeekNumber={false}
        showToday={false}
        animation="slide-up"
        showTime={showTime}
        showOk={showTime}
        locale={jaJPCustom} // #7259
        format={this.dateFormat}
        defaultValue={date || null}
        timePicker={timePickerElement}
        disabledDate={disabledDate}
      />
    );
    return (
      <div>
        <InputGroup className={'calendar-dropdown'}>
          <Picker
            animation="slide-up"
            calendar={calendar}
            onChange={this.handleTimeChange}
            getCalendarContainer={(element) => {
              if (!element
                || !$(element).parent()
                || !$(element).parent().parent()
                || !$(element).parent().parent().length) {
                return document.body;
              }
              return $(element).parent().parent()[0];
            }}
            defaultValue={date || null}
            value={date || null}
            disabled={this.props.disabled}
          >
            {({ value }) => (
              <FormControl
                type="text"
                readOnly
                disabled={this.props.disabled}
                className="ant-calendar-picker-input ant-input"
                value={dateValue}
              />
            )}
          </Picker>
          <InputGroup.Text onClick={!this.props.disabled ? handleCalendarIconClick : null} className={this.props.className}>
            {' '}<i className="bi bi-calendar3"/>
          </InputGroup.Text>
        </InputGroup>
        <MessageValidate
          errorType={this.state.errorType}
          visible={this.state.errorVisible}
          errorMessage={this.state.errorMessage}
        />
      </div>
    );
  }
}

export default DateTimeWithValidate;
